import React, { useEffect, useState } from "react";
import { Button, Space, Spin, Table } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { COLORS, recentReportscolumns } from "../../../constants";
import Notification from "../../../components/shared/Notification";

import {
  getMonthlyReport,
  getRecentReports,
  getNationalReport,
} from "~v2/http-request/mice-report";
import AppContainer from "~v2/components/AppContainer/AppContainer";
import SelectedReportDetails from "../../components/SelectedReportDetails/SelectedReportDetails";
import { formatMonthYear } from "../../../helpers/formatDate";

const MICEAdminReportPage = () => {
  const [isLoadingDownloadLocal, setisLoadingDownloadLocal] = useState(false);
  const [isLoadingDownloadNational, setisLoadingDownloadNational] =
    useState(false);

  const [dataSource, setDataSource] = useState();
  const { establishmentId } = useParams();
  const navigate = useNavigate();
  const locationData = useLocation().state;

  useEffect(() => {
    if (!locationData || !establishmentId) {
      Notification(
        "Error",
        "Please select and establishment, month and year!",
        "error"
      );
      return navigate(-1);
    }
    loadDataSource();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationData, establishmentId]);

  const loadDataSource = async () => {
    let token = localStorage.getItem("token");
    await getRecentReports(establishmentId, token).then((sources) => {
      sources.forEach((source) => {
        source.key = source._id;
        source.activity =
          source.createdAt === source.updatedAt ? "Created" : "Edited";
      });
      setDataSource(sources);
    });
  };
  const downloadLocalReport = async () => {
    let data = {
      date: formatMonthYear(locationData.month, locationData.year),
      establishmentId,
    };
    setisLoadingDownloadLocal(true);
    let token = localStorage.getItem("token");
    await getMonthlyReport(data, token)
      .then((res) => {
        if (res?.downloadLink) {
          window.open(res.downloadLink, "_blank");
        }
      })
      .finally(() => {
        setisLoadingDownloadLocal(false);
      });
  };

  const downloadNationalReport = async () => {
    const date = formatMonthYear(locationData.month, locationData.year);
    setisLoadingDownloadNational(true);
    let token = localStorage.getItem("token");
    await getNationalReport(date, token)
      .then((res) => {
        if (res?.downloadLink) {
          window.open(res.downloadLink, "_blank");
        }
      })
      .finally(() => {
        setisLoadingDownloadNational(false);
      });
  };

  const viewDayReport = async () => {
    navigate(`../mice-reports/view/no-record`, {
      state: { establishmentId },
    });
  };

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 20, color: COLORS.white }} spin />
  );

  return (
    <AppContainer title="MICE Report">
      <center>
        <div style={{ margin: "20px 0px", width: "80vw" }}>
          <SelectedReportDetails {...locationData} />
          <Space direction="vertical" size="middle" style={{ width: "100%" }}>
            <Button block type="primary" onClick={viewDayReport}>
              View Day Report
            </Button>
            <Button block type="primary" onClick={downloadLocalReport}>
              {isLoadingDownloadLocal ? (
                <Spin indicator={antIcon} />
              ) : (
                "Download Local Report"
              )}
            </Button>
            <Button block type="primary" onClick={downloadNationalReport}>
              {isLoadingDownloadNational ? (
                <Spin indicator={antIcon} />
              ) : (
                "Download National Report"
              )}
            </Button>

            <Table
              columns={recentReportscolumns}
              pagination={false}
              dataSource={dataSource}
              size={"small"}
            />
          </Space>
        </div>
      </center>
    </AppContainer>
  );
};

export default MICEAdminReportPage;
